// extracted by mini-css-extract-plugin
export default {"menuItem":"Menu_menuItem__+ZqVX","iconWrapper":"Menu_iconWrapper__RP9-q","nameWrapper":"Menu_nameWrapper__P2JJP"};